/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Send_EmailInputs */



/**
* | output |
* | --- |
* | "Couldn't send the email." |
*
* @param {Auth_Error_Send_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_send_email = /** @type {((inputs?: Auth_Error_Send_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Send_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'envoyer l'email.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo enviar el correo electrónico.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível enviar o e-mail.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile inviare l'email.")
	return /** @type {LocalizedString} */ ("Couldn't send the email.")
});